import { HTTPClient } from '@abaco/web-common/src/HTTP';
import type { PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import type { ScholanderItemMap, ScholanderRawMap } from "../models";

export default class FerrariWidgetAPI {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getScholanderList(scs_subject_id: number, subject_id: number | null, currentCampaign: number, lot_id: number | null, paging: PagingParams, rawFilters: Record<string, string>, comparators: any): Promise<PagedResults<ScholanderItemMap>> {        
        const dateBlackList = ['schol_date'];
        const filter: string[] = [];
        Object.keys(rawFilters).forEach((key: string) => {
            if (rawFilters[key].toString().length > 0) {
                let value = rawFilters[key];
                if (dateBlackList.includes(key)) {
                    value = (new Date(value).getTime()).toString();
                }
                filter.push(`${key} ${this.getComparator(key, comparators)} ${value}`)
            }
        })

        const params = {
            subject_id: scs_subject_id && subject_id ? subject_id : null,
            lot_id,
            count: paging.count,
            offset: paging.offset,
            filter,
        };

        const ep = scs_subject_id
            ? 'scs'
            : 'subjects'
        const subject = scs_subject_id
            ? scs_subject_id
            : subject_id

        const url = `/sitiagri-rest-api/api/v1/dashboard/lunelli/${ep}/${subject}/campaigns/${currentCampaign}/docs/scholander`;

        const data = (await this.http.get(url, { params })).data;

        return {
            ...data,
            records: data.records.map((item: ScholanderRawMap) => {
                return {
                    ...item,
                    schol_pos_gps: item.schol_pos_gps_x && item.schol_pos_gps_y ? `${item.schol_pos_gps_y}, ${item.schol_pos_gps_x}` : null,
                    schol_date: item.schol_date ? new Date(item.schol_date).toLocaleString('it-IT', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    }) : null,
                }
            })
        };
    }

    getComparator(k: string, comparators: any) {       
        const numberBlackList = ["schol_date", "schol_pot_idr"];
        if (numberBlackList.includes(k)) {
            return comparators[k + '_comparator']
        } else return "like"
    }
}
